export default function listButton({ productId, type }) {
    return {
        productId,
        type,
        loading: false,

        get active() {
            return Alpine.store('favorites').has(this.productId, this.type);
        },

        async toggle() {
            if (this.loading) return;
            this.loading = true;

            try {
                await Alpine.store('favorites')
                    .toggle(this.productId, this.type);
            } finally {
                this.loading = false;
            }
        }
    };
}
